export const JOIN_WINDOW_MINUTES = 10;
const FALLBACK_DURATION_MS = 4 * 60 * 60 * 1000;

interface WebinarTimingParams {
  eventStartsAt?: string | null;
  eventEndsAt?: string | null;
  status?: string;
}

export function isWebinarJoinable({ eventStartsAt, eventEndsAt, status }: WebinarTimingParams): boolean {
  if (status === 'ended' || status === 'cancelled') return false;
  if (status === 'live') return true;
  if (!eventStartsAt) return false;

  const now = Date.now();
  const start = new Date(eventStartsAt).getTime();
  const end = eventEndsAt ? new Date(eventEndsAt).getTime() : start + FALLBACK_DURATION_MS;
  const joinOpensAt = start - JOIN_WINDOW_MINUTES * 60 * 1000;

  return now >= joinOpensAt && now <= end;
}

export function isWebinarComplete({
  eventEndsAt,
  status,
}: Pick<WebinarTimingParams, 'eventEndsAt' | 'status'>): boolean {
  if (status === 'ended' || status === 'cancelled') return true;
  if (!eventEndsAt) return false;
  return Date.now() > new Date(eventEndsAt).getTime();
}
